import * as React from 'react';

import { InlineNotification } from '@coursera/cds-core';

import _t from 'i18n!nls/clips';

type Props = {
  onDismiss: () => void;
};

export const EnrollButtonErrorNotification = ({ onDismiss }: Props) => {
  const titleCopy = _t('Unable to enroll');
  const bodyCopy = _t("You can't enroll at this time. Refresh the page or contact your administrator for help.");

  return (
    <InlineNotification severity="error" title={titleCopy} onDismiss={onDismiss}>
      {bodyCopy}
    </InlineNotification>
  );
};
